import React, { Component, createRef } from "react";
import Header from "../common/layout/header";
import Footer from "../common/layout/footer";
import { BaseUrl } from "../common/config";
import discountIcon from "../assets/images/discount-icon.png";
import { http } from "../helper";
import DataTable from "react-data-table-component";
import Sidebar from "../common/sidebar";
import moment from "moment";
import CommonAlert from "../common/Commonalert";
import Popup from "../common/popup";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import { dateformatwithuktime } from "../utilityfunctions";
import * as XLSX from "sheetjs-style";
import { saveAs } from "file-saver";
//import { canAction } from "../common/permissionhelper";

class KitchenOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      temporders: [],
      priceBands: [],
      searchTextVal: "",
      loading: true,
      popupView: "",
      alertMessage: "",
      alertPopup: false,
      isElementVisible: false,
      datelabel: "Past 30 Days",
      datefilterlabel: "Past 30 Days",
      prevDatelabel: "",
      dateRange: "",
      datepickershow: false,
      datefrom: "",
      dateto: "",
      datefromLabel: "",
      datetoLabel: "",
      dateinvalid_error: false,
      datefill_error: false,
      searchstate: false,
      searchField: "OrderNumber",
      searchFieldtxt: "Order Number",
      notesPopup: false,
      note: "",
      currentOrder: [],
      orderlogs: [],
      noteError: false,
      isLoading: false,
      uploadMessage: "",
      showPopup: false,
      refreshLoading: false,
      trigerDateFilter: false,
      depots: [],
      isFilterApplied: false,
      selectedDateOption: { value: "1", label: "Past 30 Days" },
      //mainDepotList: [],
      //subDepotList: [],
      restrictedAccounts: [],
      rangeOptions: [
        { value: "1", label: "Past 30 Days" },
        { value: "3", label: "Past 90 Days" },
        { value: "6", label: "Past 180 Days" },
        { value: "1Year", label: "Past 1 Year" },
        { value: "custom", label: "Custom" },
      ],
      visibleAlert: false,
      visibleNoDataAlert: false,
      //sectorList: [],
    };
    this.searchFieldRef = createRef();
    this.searchInputRef = createRef();

    if (!sessionStorage.getItem("isLoggedIn")) window.location.href = "/";
    if (
      JSON.parse(sessionStorage.getItem("authData")) != "" &&
      !JSON.parse(
        sessionStorage.getItem("authData"),
      ).adminRole.permissions.includes("manage_orders")
    ) {
      window.location.href = "/unauthorized";
    }
    this.dropdownRef = React.createRef();
    this.dropdownMobileRef = React.createRef();
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.updateNoteLog = this.updateNoteLog.bind(this);
    this.hideNotePopup = this.hideNotePopup.bind(this);
    this.openFilter = this.openFilter.bind(this);
  }

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.getPriceBands();
    this.fetchRestrictedAccounts().then(() => {
      this.getAllOrders();
    });
    //this.fetchSectors();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.trigerDateFilter === true) {
      this.applyOrderFilters();
      this.setState({ trigerDateFilter: false });
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
    clearInterval(this.interval);
  }

  handleClickOutside = (event) => {
    if (this.dropdownRef && !this.dropdownRef.current.contains(event.target)) {
      this.setState({ isElementVisible: false });
    }
  };

  openFilter = () => {
    this.setState((prevState) => ({
      isElementVisible: !prevState.isElementVisible,
    }));
    this.clearforOpenFilter();
  };

  // fetchSectors = () => {
  //   let URL = BaseUrl + "admin/product/masterentries/sectors";
  //   http
  //     .get(URL)
  //     .then((res) => {
  //       if (res.data.success) {
  //         this.setState({ sectorList: res.data.data });
  //       }
  //     })
  //     .catch((err) => console.log(err));
  // };

  getAllOrders() {
    var dateval = "";
    var dateval2 = "";
    if (this.state.datefrom && this.state.dateto) {
      dateval = this.state.datefrom ? new Date(this.state.datefrom) : "";
      dateval = format(dateval, "yyyy-MM-dd");
      dateval2 = new Date(this.state.dateto);
      dateval2 = format(dateval2, "yyyy-MM-dd");
    }
    let payload = {
      orderdays:
        this.state.dateRange && typeof (this.state.dateRange === "number")
          ? this.state.dateRange
          : this.state.dateRange && typeof (this.state.dateRange === "string")
            ? ""
            : 30,
      datefrom: dateval ? dateval : "",
      dateto: dateval2 ? dateval2 : "",
      from: "backend",
    };
    let URL = BaseUrl + "admin/kitchen-orders";
    //let URL = BaseUrl + "admin/orders";
    if (sessionStorage.getItem("authData")) {
      var loginemail = JSON.parse(
        sessionStorage.getItem("authData"),
      ).adminEmail;
    }
    http
      .post(URL, payload)
      .then((response) => {
        let responseData = [];
        const { restrictedAccounts } = this.state;
        if (loginemail === "karthik@k2bsolutions.in") {
          responseData = response.data.data;
        } else {
          responseData = response.data.data.filter(
            (order) => !restrictedAccounts.includes(order.accountCode),
          );
        }
        this.setState({
          orders: responseData,
          loading: false,
          temporders: responseData,
          alertPopup: false,
          alertMessage: "",
          refreshLoading: false,
          searchstate: false,
          searchField: "",
          searchFieldtxt: "Order Number",
          searchTextVal: "",
        });
        var element = document.querySelectorAll(".fa-refresh");
        element.forEach((row) => {
          row.classList.remove("fa-spin");
        });
      })
      .catch((err) => {
        var element = document.querySelectorAll(".fa-refresh");
        element.forEach((row) => {
          row.classList.remove("fa-spin");
        });
        this.setState({
          alertPopup: true,
          loading: false,
          alertMessage: `The Server is busy, please try after sometime`,
        });
      });
    // let URL1 = BaseUrl + `admin/getdepots`;
    // http
    //   .get(URL1)
    //   .then((response) => {
    //     let responseData = response.data.data;
    //     const uniqueDepots = Array.from(
    //       new Set(responseData.map((item) => item.mainDepot)),
    //     ).map((mainDepot) =>
    //       responseData.find((item) => item.mainDepot === mainDepot),
    //     );
    //     this.setState({ subDepotList: responseData });
    //     this.setState({ depots: responseData });
    //     this.setState({ mainDepotList: uniqueDepots });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  }

  getPriceBands() {
    let URL = BaseUrl + "admin/pricebands";
    if (sessionStorage.getItem("authData")) {
      var loginemail = JSON.parse(
        sessionStorage.getItem("authData"),
      ).adminEmail;
    }
    http
      .get(URL)
      .then(async (response) => {
        console.log(response);
        let responseData = [];
        responseData = response.data.data;
        this.setState({ priceBands: responseData });
      })
      .catch((error) => {
        console.error("Error updating customer status:", error);
      });
  }

  getAllOrdersforsearch() {
    this.setState({ alertPopup: false, searchstate: true });
    let authData = JSON.parse(sessionStorage.getItem("authData"));
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL =
      BaseUrl +
      "admin/searchorders/" +
      this.state.searchField +
      "/" +
      encodeURIComponent(this.state.searchTextVal);
    http
      .get(URL)
      .then((response) => {
        let responseData = [];
        responseData = response.data.data;
        this.setState({ orders: responseData, loading: false });
        var element = document.querySelectorAll(".fa-refresh");
        element.forEach((row) => {
          row.classList.remove("fa-spin");
        });
      })
      .catch((err) => {
        this.setState({ loading: false });
        var element = document.querySelectorAll(".fa-refresh");
        element.forEach((row) => {
          row.classList.remove("fa-spin");
        });
      });
  }

  priceFormat(price) {
    if (price == null || isNaN(price)) {
      return "£0.00";
    }
    return price.toLocaleString("en-US", {
      style: "currency",
      currency: "GBP",
      minimumFractionDigits: 2,
    });
  }

  vatAmountCalcuation(order) {
    var totalAmount = 0;
    order.items.map((item, value) => {
      if (item.TaxCode !== "" && item.TaxCode === "T1") {
        totalAmount += item.LinePrice;
      }
    });
    return totalAmount;
  }
  /* ************ get the account details of the particular order ******************* */
  getOrderaccountdetails(accountCode, orderrow) {
    this.setState({
      popupView: (
        <Popup
          extClass="order-pop"
          headMoreTxt={
            <>
              <div className="order-top">
                <div className="bottom order-flex">
                  {/* Changed for getting account details of particular order  */}
                  <div className="order_no_details">
                    <h3>Order No - {orderrow.OrderNumber}</h3>
                    <p>
                      Order Placed on:{" "}
                      <span className="date">
                        {" "}
                        {moment(orderrow.createdAt).format(
                          "DD/MM/YYYY hh:mm A",
                        )}
                      </span>{" "}
                    </p>
                    <p>
                      Order Delivery on:{" "}
                      <span className="date"> {orderrow.DateRequired} </span>
                    </p>
                    {/* {orderrow.PaymentMethod === "A" && (
                      <p>
                        Payment Method:
                        <span className="pay">
                          {" "}
                          {orderrow.OrderPaid === "YES"
                            ? "Paid (Pay Later)"
                            : "Pay Later"}
                        </span>
                      </p>
                    )}
                    {orderrow.PaymentMethod === "K" && (
                      <p>
                        Payment Method:
                        <span className="pay"> Online Payment</span>
                      </p>
                    )} */}
                    <p>
                      Status:
                      <span className="pay"> {orderrow.OrderStatus}</span>
                    </p>
                    {/* Only show placedBy if it exists */}
                    {/* {orderrow.placedBy &&
                      orderrow.placedBy !== orderrow.accountCode && (
                        <p>
                          Order Placed by:{" "}
                          <span className="pay">{orderrow.placedBy}</span>{" "}
                        </p>
                      )} */}
                  </div>
                  <div className="order_account_details">
                    <p>
                      Name:{" "}
                      <span className="date">{orderrow.accountName}</span>{" "}
                    </p>
                    <p>
                      Account Code:{" "}
                      <span className="date">{orderrow.accountCode}</span>{" "}
                    </p>
                    <p>
                      Email Address:{" "}
                      <span className="pay">{orderrow.accountEmail}</span>
                    </p>
                    <p>
                      Address:{" "}
                      <span className="pay">{orderrow.accountAddress}</span>
                    </p>
                    {orderrow.PODetails && (
                      <p>
                        PO Details:{" "}
                        <span className="pay">{orderrow.PODetails}</span>
                      </p>
                    )}
                  </div>
                </div>
              </div>
            </>
          }
          closebtn={
            <>
              <div className="order-top">
                <div className="head">
                  <h4>Kitchen Order Details - {orderrow.OrderNumber}</h4>
                </div>
                <span
                  onClick={() => this.setState({ popupView: "" })}
                  className="close"
                ></span>
              </div>
            </>
          }
          bodyMoreTxt={
            <>
            {/* NOTE */}
            
            <div className="modal-table">
              <h4 className="item-title">Ordered Items</h4>
              <div className="checkout-table">
                <div className="table_overflow">
                  <table>
                    <tbody>
                      <tr>
                        <td colspan={5} className="is-loading">
                          <div>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                            <p></p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            </>
          }
        />
      ),
      alertPopup: false,
      loading: true,
    });
    let URL = BaseUrl + "admin/updatekitchenorderitems/" + accountCode + "/" + orderrow.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        let responseData = [];
        responseData = response.data.data[0];
        this.setState({ loading: false });
        this.viewOrderDetails(responseData);
      })
      .catch((err) => {
        this.setState({ loading: false });
      });
    }

  closePopup = () => {
    this.setState({ showPopup: false, uploadMessage: "" });
  };

  orderRecordsTotal = (orders) => {
    let totalOrderAmount = 0;
    let orderCount = 0;
    orders.forEach((order) => {
      orderCount++;
      if (this.state.searchTextVal.toLowerCase() === "orders placed") {
        if (order.OrderStatus !== "Cancelled") {
          totalOrderAmount +=
            order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
        }
      } else if (
        this.state.searchFieldtxt === "Order Status" &&
        this.state.searchTextVal === "Cancelled"
      ) {
        totalOrderAmount +=
          order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
      } else if (order.OrderStatus !== "Cancelled") {
        totalOrderAmount +=
          order.OrderTotalWithVat !== undefined ? order.OrderTotalWithVat : 0;
      }
      if (order.OrderTotalWithVat === undefined) {
        console.log(order);
      }
    });
    return {
      totalOrderAmount: this.priceFormat(totalOrderAmount),
      totalOrderCount: orderCount,
    };
  };

  viewOrderDetails(order) {
    var ordertotal = 0;
    var subTotal = 0;
    this.setState({ alertPopup: false, alertMessage: "" });
    const sortedItems = [...order.items].sort((a, b) => {
      if (a.UnitPrice === 0 && b.UnitPrice !== 0) return 1;
      if (a.UnitPrice !== 0 && b.UnitPrice === 0) return -1;
      if (a.ProductNumber === "77775" && b.ProductNumber !== "77775") return 1;
      if (b.ProductNumber === "77775" && a.ProductNumber !== "77775") return -1;
      return 0;
    });
    sortedItems.map((item) => {
      ordertotal += item.LinePrice;
    });
    sortedItems.map((item) => {
      subTotal += item.UnitPrice * item.QuantityOrdered;
    });
    var vatTotalAmount = this.vatAmountCalcuation(order);
    var vatAmount = 0;
    if (vatTotalAmount > 0) {
      vatAmount = (vatTotalAmount / 100) * 20;
      ordertotal = ordertotal + vatAmount;
    }
    let popupResult = (
      <Popup
        extClass="order-pop my-order-details-pop"
        headMoreTxt={
          <>
            <div className="order-top">
              <div className="bottom order-flex">
                {/* Changed for getting account details of particular order  */}
                <div className="order_no_details">
                  <h3>Order No - {order.OrderNumber}</h3>
                  <p>
                    Order Placed on:{" "}
                    <span className="date">
                      {" "}
                      {moment(order.createdAt).format("DD/MM/YYYY hh:mm A")}
                    </span>{" "}
                  </p>
                  <p>
                    Order Delivery on:{" "}
                    <span className="date"> {order.DateRequired} </span>
                  </p>
                  {/* {order.PaymentMethod === "A" && (
                    <p>
                      Payment Method:
                      <span className="pay">
                        {" "}
                        {order.OrderPaid === "YES"
                          ? "Paid (Pay Later)"
                          : "Pay Later"}
                      </span>
                    </p>
                  )}
                  {order.PaymentMethod === "K" && (
                    <p>
                      Payment Method:
                      <span className="pay"> Online Payment</span>
                    </p>
                  )} */}
                  <p>
                    Status:<span className="pay"> {order.OrderStatus}</span>
                  </p>
                  {/* Only show placedBy if it exists */}
                  {/* {order.placedBy && order.placedBy != order.accountCode && (
                    <p>
                      Order Placed by:{" "}
                      <span className="pay">{order.placedBy} </span>{" "}
                    </p>
                  )} */}
                </div>
                <div className="order_account_details">
                  <p>
                    Name: <span className="date">{order.accountName}</span>{" "}
                  </p>
                  <p>
                    Account Code:{" "}
                    <span className="date">{order.accountCode}</span>{" "}
                  </p>
                  <p>
                    Email Address:{" "}
                    <span className="pay">{order.accountEmail}</span>
                  </p>
                  <p>
                    Address: <span className="pay">{order.accountAddress}</span>
                  </p>
                  {order.PODetails && (
                    <p>
                      PO Details: <span className="pay">{order.PODetails}</span>
                    </p>
                  )}
                  <p>
                    Price Band:{" "}
                    <span className="date">{order.Priceband}</span>{" "}
                  </p>
                </div>
              </div>
            </div>
          </>
        }
        closebtn={
          <>
            <div className="pop-header-top order-top">
              <div className="head">
                <h4>Kitchen Order Details - {order.OrderNumber}</h4>
              </div>
              <span
                onClick={() => this.setState({ popupView: "" })}
                className="close"
              ></span>
            </div>
          </>
        }
        bodyMoreTxt={
          <>
                     
            <div className="modal-table">
              <h4 className="item-title">Ordered Items</h4>
              <div className="checkout-table">
                <div className="table_overflow">
                  <table>
                    <thead>
                      <tr>
                        <td>Product</td>
                        <td>Unit of Sale</td>
                        <td>Quantity</td>
                        {/* <td align="center">Price</td>
                        <td align="right">Total</td> */}
                      </tr>
                    </thead>
                    <tbody>
                      {/* Added Special offer and product number like frontend by k2b Sangeetha   */}
                      {sortedItems.map((item, index) => {
                        return (
                          item.QuantityOrdered > 0 && (
                            <tr
                              key={index}
                              className={(item.productType === 'Free' || item.productType === 'CH' ) ? 'free-prod-bg' : ''}
                            >
                              <td
                                data-title="Product"
                                className="data-product-hide"
                              >
                                {this.str_replace(item.Description)} (
                                {item.ProductNumber.includes("_")
                                  ? item.ProductNumber.substring(
                                      0,
                                      item.ProductNumber.indexOf("_"),
                                    )
                                  : item.ProductNumber}
                                )
                                {item.TaxCode !== "" &&
                                  item.TaxCode === "T1" && (
                                    <span className="color-red">*</span>
                                  )}
                                {item.OfferFlag == "true" && (
                                    <span className="offer-tag-wrap">
                                      <span className="offer-tag">
                                        <img
                                          src={discountIcon}
                                          alt="Offer"
                                          className="tag-icon"
                                        />
                                        Special Offer
                                      </span>
                                    </span>
                                  )}
                              </td>
                              <td data-title="Unit of Sale">
                                {item.PricingUnit}
                              </td>
                              <td data-title="Quantity">
                                {item.QuantityOrdered}
                              </td>
                              {/* <td data-title="Price" align="center">
                                {this.priceFormat(item.UnitPrice)}
                              </td>
                              <td data-title="Total" align="right">
                                {this.priceFormat(item.LinePrice)}
                              </td> */}
                            </tr>
                          )
                        );
                      })}
                      {/* Added Special offer and product number like frontend by k2b Sangeetha   */}
                    </tbody>
                    <thead className="ord-grand-total">
                      {order.OrderNote !== "" && order.OrderNote !== null && (
                        <tr>
                          <td align="left" width={120} colSpan="7">
                            Order Notes:{" "}
                            <span className="order_remarks">
                              {" "}
                              {this.getOrderNotes(order.OrderNote)}
                            </span>
                          </td>
                        </tr>
                      )}
                      {/* <tr>
                        <td align="right" width={120} colSpan="4">
                          Subtotal:
                        </td>
                        <td align="right">{this.priceFormat(subTotal)}</td>
                      </tr> */}
                      {/* {vatAmount > 0 && (
                        <tr>
                          <td
                            align="right"
                            width={120}
                            colSpan="4"
                            className="td-vat-fee"
                          >
                            <span className="strong">
                              VAT{" "}
                              <span className="vat-txt">
                                (20% of{" "}
                                <span className="vat-amt">
                                  {this.priceFormat(vatTotalAmount)}
                                </span>
                                )<span className="color-red">*</span>:
                              </span>
                            </span>
                          </td>
                          <td className="cart-prod-vat" align="right">
                            {this.priceFormat(vatAmount)}
                          </td>
                        </tr>
                      )} */}
                      {/* <tr>
                        <td align="right" width={120} colSpan="4">
                          Shipping:
                        </td>
                        <td align="right">
                          <span className="color-red">FREE</span>
                        </td>
                      </tr> */}
                      {/* {order.promoCode && order.promoCodeDiscount > 0 && (
                        <tr>
                          <td
                            align="right"
                            width={120}
                            colSpan="4"
                            className="td-vat-fee"
                          >
                            <span className="strong">
                              {" "}
                              <i>
                                Promo Code Discount{" "}
                                <span className="vat-txt">
                                  ( {order.promoCodeDiscount}% of £
                                  {subTotal + vatAmount})
                                </span>
                              </i>
                              <span className="colon-bold"> :</span>
                            </span>
                          </td>
                          <td align="right" className="cart-prod-vat">
                            - {this.priceFormat(order.promoCodeAppliedAmount)}
                          </td>
                        </tr>
                      )} */}
                      {/* <tr>
                        <td align="right" width={120} colSpan="4">
                          Grand Total:
                        </td>
                        <td align="right">
                          {this.priceFormat(order.OrderTotalWithVat)}
                        </td>
                      </tr> */}
                    </thead>
                  </table>
                </div>
              </div>
            </div>
            {order.OrderDiscount > 0 && (
              <span className="tot-ofr-applied">
                {order.OrderDiscount}% discount applied for this order!
              </span>
            )}
            
              <span className="tot-ofr-applied">
                Note: This is a Kitchen Internal Ordering account. Product prices are set to £0 for internal operations and do not reflect actual selling prices.
              </span>
           
          </>
        }
      />
    );
    this.setState({ popupView: popupResult });
  }

  str_replace(product_name) {
    if (product_name !== "") {
      product_name = product_name.replaceAll("amp;", "&");
      product_name = product_name.replaceAll("apos;'", "'' ");
      product_name = product_name.replaceAll("quot;'", "'' ");
      return product_name;
    } else {
      return product_name;
    }
  }

  getOrderNotes(OrderNote) {
    var note_test = OrderNote.replaceAll(" PIXHALLCSL", "");
    note_test = note_test.replaceAll("amp;", "&");
    note_test = note_test.replaceAll("apos;", "'' ");
    note_test = note_test.replaceAll("apos;'", "'' ");
    note_test = note_test.replaceAll("quot;'", "'' ");
    note_test = note_test.replaceAll("quot;", "'' ");
    note_test = note_test.replaceAll("'' '", "'' ");
    return note_test;
  }

  handleReset = () => {
    this.setState({
      orders: this.state.temporders,
      searchstate: false,
      searchField: "",
      searchFieldtxt: "Order Number",
      searchTextVal: "",
    });
    if (this.searchFieldRef.current) {
      this.searchFieldRef.current.selectedIndex = 1;
    }
    if (this.searchInputRef.current) {
      this.searchInputRef.current.value = "";
    }
  };

  //Auto-Suggestions for Price Band
  handlePriceBandChange = (e) => {
    const value = e.target.value;
    this.setState({
      searchTextVal: value,
      alertPopup: false,
      showPopup: false,
    });
    if (value.trim() === "") {
      this.setState({ suggestions: [] });
      return;
    }
    const suggestions = [
      ...new Set(
        this.state.priceBands
          .filter(
            (item) => item && item.toLowerCase().includes(value.toLowerCase()),
          ),
      ),
    ];
    this.setState({ suggestions });
  };

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({ searchTextVal: value });
    const lowercasedValue = value.toLowerCase().trim();
    const searchData = this.state.temporders.filter((item) => {
      if (lowercasedValue === "orders placed") {
        return true;
      } else if (
        Number.isInteger(Number(lowercasedValue)) &&
        this.state.searchFieldtxt === "Order Number"
      ) {
        return item.OrderNumber.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        this.state.searchFieldtxt === "Account Code"
      ) {
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      } 
      // else if (this.state.searchField === "placedBy") {
      //   if (!lowercasedValue) return true;
      //   if (!item.placedBy) return false;
      //   const placedByLower = item.placedBy.toLowerCase();
      //   // Only allow HO or Chef orders
      //   if (
      //     !placedByLower.includes("(ho account)") &&
      //     !placedByLower.includes("(chef account)")
      //   ) {
      //     return false;
      //   }
      //   // Extract account code before bracket
      //   const accountCodePart = placedByLower.split("(")[0].trim();
      //   return accountCodePart.includes(lowercasedValue);
      // } 
      // else if (
      //   lowercasedValue !== "a" &&
      //   lowercasedValue !== "k" &&
      //   this.state.searchField === "mainDepot"
      // ) {
      //   return (
      //     item.mainDepot &&
      //     item.mainDepot.toLowerCase().includes(lowercasedValue)
      //   );
      // } 
      // else if (
      //   lowercasedValue !== "a" &&
      //   lowercasedValue !== "k" &&
      //   this.state.searchField === "subDepot"
      // ) {
      //   return (
      //     item.subDepot && item.subDepot.toLowerCase().includes(lowercasedValue)
      //   );
      // } 
      else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        this.state.searchField === "OrderStatus"
      ) {
        return item.OrderStatus.toLowerCase().includes(lowercasedValue);
      }
      // else if (
      //   lowercasedValue === "a" ||
      //   (lowercasedValue === "k" && this.state.searchField === "PaymentMethod")
      // ) {
      //   return item.PaymentMethod.toLowerCase().includes(lowercasedValue);
      // } 
      // else if (this.state.searchField === "hasPromoPinsa") {
      //   if (lowercasedValue === "") {
      //     return true;
      //   }
      //   if (!item.hasPromoPinsa) {
      //     return false;
      //   }
      //   if (lowercasedValue === "all") {
      //     return true;
      //   }
      //   return (
      //     item.clientInfo &&
      //     item.clientInfo[0]?.Sectors &&
      //     item.clientInfo[0].Sectors.toLowerCase().includes(lowercasedValue)
      //   );
      // }
    });
    this.setState({ orders: searchData, searchstate: true });
  };

  handleNoteChange = async (value) => {
    this.setState({ note: value.trim(), noteError: false });
  };

  filterData = () => {
    const value = this.state.searchTextVal;
    const lowercasedValue = value.toLowerCase().trim();
    const searchData = this.state.temporders.filter((item) => {
      if (lowercasedValue === "orders placed") {
        return true;
      } else if (
        Number.isInteger(Number(lowercasedValue)) &&
        this.state.searchFieldtxt === "Order Number"
      ) {
        return item.OrderNumber.toLowerCase().includes(lowercasedValue);
      } else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        this.state.searchFieldtxt === "Account Code"
      ) {
        return item.accountCode.toLowerCase().includes(lowercasedValue);
      } else if (this.state.searchField === "PriceBand") {
        return (
          item.Priceband &&
          item.Priceband.toLowerCase().includes(lowercasedValue)
        );
      } 
      // else if (this.state.searchField === "mainDepot") {
      //   return (
      //     item.mainDepot &&
      //     item.mainDepot.toLowerCase().includes(lowercasedValue)
      //   );
      // } 
      // else if (this.state.searchField === "subDepot") {
      //   return (
      //     item.subDepot && item.subDepot.toLowerCase().includes(lowercasedValue)
      //   );
      // } 
      else if (
        lowercasedValue !== "a" &&
        lowercasedValue !== "k" &&
        this.state.searchField === "OrderStatus"
      ) {
        return item.OrderStatus.toLowerCase().includes(lowercasedValue);
      } 
      // else if (
      //   lowercasedValue === "a" ||
      //   (lowercasedValue === "k" && this.state.searchField === "PaymentMethod")
      // ) {
      //   return item.PaymentMethod.toLowerCase().includes(lowercasedValue);
      // } 
      // else if (this.state.searchField === "placedBy") {
      //   if (!lowercasedValue) return true;
      //   if (!item.placedBy) return false;
      //   const placedByLower = item.placedBy.toLowerCase();
      //   // Only allow HO or Chef orders
      //   if (
      //     !placedByLower.includes("(ho account)") &&
      //     !placedByLower.includes("(chef account)")
      //   ) {
      //     return false;
      //   }
      //   // Extract account code before bracket
      //   const accountCodePart = placedByLower.split("(")[0].trim();
      //   return accountCodePart.includes(lowercasedValue);
      // } 
      // else if (this.state.searchField === "hasPromoPinsa") {
      //   if (lowercasedValue === "") {
      //     return true;
      //   }
      //   if (!item.hasPromoPinsa) {
      //     return false;
      //   }
      //   if (lowercasedValue === "all") {
      //     return true;
      //   }
      //   return (
      //     item.clientInfo &&
      //     item.clientInfo[0]?.Sectors &&
      //     item.clientInfo[0].Sectors.toLowerCase().includes(lowercasedValue)
      //   );
      // }
    });

    this.setState({ orders: searchData, alertPopup: false, searchstate: true });
  };

  alertPopupclose = () => {
    this.setState({ visibleAlert: false });
  };

  handleConfirmExportToExcel = () => {
    const { orders } = this.state;
    if (!orders || orders.length === 0) {
      // Show no data popup
      this.setState({ visibleNoDataAlert: true });
      return;
    }
    this.setState({ visibleAlert: true });
  };

  handleCloseNoDataAlert = () => {
    this.setState({ visibleNoDataAlert: false });
  };

  // Export Records
  handleExportToExcel = () => {
    const { orders, datefromLabel, datetoLabel, datelabel } = this.state;
    const { totalOrderCount, totalOrderAmount } =
      this.orderRecordsTotal(orders);
    let dateRangeText = "";
    if (datefromLabel && datetoLabel) {
      dateRangeText = `From ${this.formatDate(datefromLabel)} to ${this.formatDate(datetoLabel)}`;
    } else {
      dateRangeText = datelabel;
    }
    const firstRowText = `Total Records: ${totalOrderCount} (${dateRangeText})`;
    const headers = [
      "Order #",
      "Account Code",
      "Account Name",
      "Email Address",
      "Price Band",
      "Ordered Date",
      "Delivery Date",
      // "Payment Method",
      "Status",
      //"Order Total (Incl. of VAT)",
    ];
    const headerStyle = {
      font: { bold: true },
      alignment: { horizontal: "left" },
    };
    const styledHeaders = headers.map((text) => ({ v: text, s: headerStyle }));
    const rows = orders.map((order) => [
      order.OrderNumber,
      order.accountCode,
      order.accountName,
      order.accountEmail,
      order.Priceband,
      moment(order.createdAt).format("DD/MM/YYYY"),
      order.DateRequired,
      // order.PaymentMethod === "A"
      //   ? order.OrderPaid === "YES"
      //     ? "Paid (Pay Later)"
      //     : "Pay Later"
      //   : "Online Payment",
      order.OrderStatus,
      // {
      //   v: this.priceFormat(order.OrderTotalWithVat),
      //   s: { alignment: { horizontal: "right" } },
      // },
    ]);
    const worksheetData = [
      [
        {
          v: firstRowText,
          s: { font: { bold: true }, alignment: { horizontal: "left" } },
        },
      ],
      styledHeaders,
      ...rows,
    ];
    const columnWidths = headers.map((header, index) => {
      let maxLength = header.length;
      rows.forEach((row) => {
        maxLength = Math.max(maxLength, String(row[index]).length);
      });
      return { wch: maxLength + 2 };
    });
    const ws = XLSX.utils.aoa_to_sheet(worksheetData);
    ws["!merges"] = [
      {
        s: { r: 0, c: 0 },
        e: { r: 0, c: headers.length - 1 },
      },
    ];
    ws["!cols"] = columnWidths;
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Kitchen Orders");
    const exportDateTime = moment().format("DD-MM-YYYY");
    //const exportDateTime = moment().format("DD-MM-YYYY_HH-mm");
    const fileName = `Tugo Kitchen Order Report-${exportDateTime}.xlsx`;
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
    });
    saveAs(blob, fileName);
    this.setState({ visibleAlert: false });
  };

  orderTotalValue(items) {
    return items.reduce((total, item) => total + item.LinePrice, 0);
  }

  orderRefresh(order) {
    var loginDetails = {};
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    var current = this;
    var numberOfAjaxCAllPending = 0;
    var timeInterval = 20000;
    var element = document.getElementById(
      "refresh_order_id" + order.OrderNumber,
    );
    element.classList.add("fa-spin");
    this.setState({ alertPopup: false });
    let URL =
      BaseUrl +
      "updatekitchenorderitems/" +
      order.accountCode +
      "/" +
      order.OrderNumber;
    http
      .get(URL)
      .then((response) => {
        numberOfAjaxCAllPending++;
        let responseData = [];
        responseData = response.data.data[0];
        this.setState(
          (prevState) => ({
            orders: prevState.orders.map((o) =>
              o.OrderNumber === responseData.OrderNumber ? responseData : o,
            ),
            temporders: prevState.temporders.map((o) =>
              o.OrderNumber === responseData.OrderNumber ? responseData : o,
            ),
            alertPopup: false,
            alertMessage: "",
            loading: false,
          }),
          () => {
            if (this.state.searchstate) {
              this.filterData();
            }
          },
        );
        element.classList.remove("fa-spin");
        clearInterval(myInterval);
      })
      .catch((err) => {
        console.log(err);
        current.setState({
          alertPopup: true,
          alertMessage: "The Server is busy, please try after sometime",
        });
      });
    var myInterval = setInterval(function () {
      if (numberOfAjaxCAllPending == 0) {
        numberOfAjaxCAllPending++;
        timeInterval = "";
        current.setState({
          alertPopup: true,
          alertMessage: "The Server is busy, please try after sometime",
        });
      }
    }, timeInterval);
  }

  handleApplyOrderFilters() {
    console.log("datefilter apply");
    this.setState({ trigerDateFilter: true });
  }

  fetchRestrictedAccounts() {
    return http
      .get(BaseUrl + "admin/accountcodelist")
      .then((res) => {
        const ids = res.data?.data?.map((acc) => acc.accountCode);
        this.setState({ restrictedAccounts: ids || [] });
      })
      .catch((err) => {
        console.error("Failed to load restricted accounts", err);
      });
  }

  applyOrderFilters() {
    let dateinvalid = false;
    if (this.state.dateRange !== "") {
      this.setState({
        isElementVisible: false,
        loading: true,
        alertPopup: false,
        isElementVisibleMobile: false,
        dateinvalid_error: false,
        datefill_error: false,
      });
      var payload = {
        orderdays: this.state.dateRange,
        datefrom: "",
        dateto: "",
      };
      if (this.state.dateRange === "custom") {
        if (this.state.datefrom && this.state.dateto) {
          var dateval = new Date(this.state.datefrom);
          dateval = format(dateval, "yyyy-MM-dd");
          var dateval2 = new Date(this.state.dateto);
          dateval2 = format(dateval2, "yyyy-MM-dd");
          this.setState({
            datefromLabel: this.state.datefrom,
            datetoLabel: this.state.dateto,
            datefill_error: false,
          });
          payload = {
            orderdays: "",
            datefrom: dateval,
            dateto: dateval2,
          };
        } else {
          dateinvalid = true;
          this.setState({
            datefill_error: true,
            isElementVisible: true,
            loading: false,
          });
        }
      } else {
        this.setState({ datelabel: this.state.selectedDateOption.label });
        payload = {
          orderdays: this.state.dateRange,
          datefrom: "",
          dateto: "",
        };
        this.setState({
          datefromLabel: "",
          datetoLabel: "",
        });
      }
      if (!dateinvalid) {
        let URL = BaseUrl + "admin/kitchen-orders";
        //let URL = BaseUrl + "admin/orders";
        if (sessionStorage.getItem("authData")) {
          var loginemail = JSON.parse(
            sessionStorage.getItem("authData"),
          ).adminEmail;
        }
        http
          .post(URL, payload)
          .then((response) => {
            let responseData = [];
            const { restrictedAccounts } = this.state;
            if (loginemail === "karthik@k2bsolutions.in") {
              responseData = response.data.data;
            } else {
              responseData = response.data.data.filter(
                (order) => !restrictedAccounts.includes(order.accountCode),
              );
            }
            this.setState(
              {
                orders: responseData,
                temporders: responseData,
                loading: false,
              },
              () => {
                if (this.state.searchstate) {
                  this.filterData();
                }
              },
            );
          })
          .catch((err) => {
            console.log("Error:", err);
            this.setState({ loading: false });
          });
      }
    }
  }

  clearFilterOrderSearch() {
    if (!this.state.isFilterApplied) {
      this.setState({
        selectedDateOption: { value: "1", label: "Past 30 Days" },
        dateRange: 30,
        trigerDateFilter: true,
      });
    } else {
      this.clearTempFilterValues();
      this.setState({ isFilterApplied: false });
    }
  }

  clearforOpenFilter() {
    this.setState({ isFilterApplied: false });
    this.clearTempFilterValues();
  }

  clearTempFilterValues() {
    var currentDateLabel = "";
    if (this.state.datefromLabel && this.state.datetoLabel) {
      currentDateLabel = "Custom";
    } else {
      currentDateLabel = this.state.datelabel;
    }
    console.log(currentDateLabel);
    const selectedFilterOption = this.state.rangeOptions.find(
      (range) => range.label === currentDateLabel,
    );
    var tempVal = {};
    if (selectedFilterOption && selectedFilterOption.label === "Custom") {
      tempVal = {
        datepickershow: true,
        selectedDateOption: selectedFilterOption,
        datefrom: this.state.datefromLabel,
        dateto: this.state.datetoLabel,
      };
    } else {
      tempVal = {
        datefrom: null,
        dateto: null,
        datepickershow: false,
        selectedDateOption: selectedFilterOption,
      };
    }
    this.setState(tempVal);
  }

  updateDateRange = (value) => {
    if (value !== "") {
      var valueDates = "";
      if (value == "1") {
        valueDates = 30;
      } else if (value == "3") {
        valueDates = 30 * 3;
      } else if (value == "6") {
        valueDates = 30 * 6;
      } else if (value == "1Year") {
        valueDates = 365;
      } else if (value == "custom") {
        valueDates = "custom";
      }
      this.setState({ dateRange: valueDates, dateinvalid_error: false });
    }
  };

  handleFilterChange = (e) => {
    this.setState({ isFilterApplied: true, selectedDateOption: e });
    if (e.value !== "") {
      var valueDates = "";
      if (e.value == "1") {
        valueDates = 30;
        this.setState({
          datepickershow: false,
          datefilterlabel: "Past 30 Days",
        });
      } else if (e.value == "3") {
        valueDates = 30 * 3;
        this.setState({
          datepickershow: false,
          datefilterlabel: "Past 90 Days",
        });
      } else if (e.value == "6") {
        valueDates = 30 * 6;
        this.setState({
          datepickershow: false,
          datefilterlabel: "Past 180 Days",
        });
      } else if (e.value == "1Year") {
        valueDates = 365;
        this.setState({
          datepickershow: false,
          datefilterlabel: "Past 1 Year",
        });
      } else if (e.value == "custom") {
        valueDates = "custom";

        this.setState({ datepickershow: true, datefilterlabel: "" });
      }
      this.setState({ dateRange: valueDates, dateinvalid_error: false });
    }
  };

  DateChange(value, type) {
    this.setState({ isFilterApplied: true });
    if (type == "from") {
      this.setState({ datefrom: value, dateinvalid_error: false });
    } else if (type == "to") {
      var dateval = new Date(this.state.datefrom);
      dateval = format(dateval, "yyyy-MM-dd");

      var dateval2 = new Date(value);
      dateval2 = format(dateval2, "yyyy-MM-dd");

      if (dateval > dateval2) {
        this.setState({ dateto: "", dateinvalid_error: true });
      } else {
        this.setState({ dateto: value, dateinvalid_error: false });
      }
    }
  }

  formatDate(dateString) {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    return `${day}/${month}/${year}`;
  }

  handleSearchFieldChange = (event) => {
    const selectedOption = this.searchFieldRef.current.selectedOptions[0];
    const value = this.searchFieldRef.current.value;
    let textval = selectedOption ? selectedOption.innerText : "";
    // if (value === "placedBy") {
    //   textval = "HO/Chef account code";
    // }
    this.setState({
      searchField: value,
      searchFieldtxt: textval,
      searchTextVal: "",
    });
    // if (value === "hasPromoPinsa") {
    //   this.setState({
    //     searchField: value,
    //     searchFieldtxt: textval,
    //     searchTextVal: "",
    //   });
    // } 
    // else {
    //   this.setState({
    //     searchField: value,
    //     searchFieldtxt: textval,
    //     searchTextVal: "",
    //   });
    // }
    // Clear the input value
    if (this.searchInputRef.current) {
      this.searchInputRef.current.value = "";
    }
  };

  handleSearchFieldChange1 = (event) => {
    const textval = event.target.value;
    this.setState({ searchTextVal: textval }, () => {
      this.getAllOrdersforsearch();
    });
  };

  renderSearchInput = () => {
    const { searchTextVal } = this.state;
    const searchField = this.searchFieldRef.current
      ? this.searchFieldRef.current.value
      : "";
    // if (searchField === "PaymentMethod") {
    //   return (
    //     <div className="orders-dropdown">
    //       <select
    //         className="search-ord"
    //         ref={this.searchInputRef}
    //         onChange={this.handleChange}
    //       >
    //         <option value="">Select</option>
    //         <option value="K">Online Payment</option>
    //         <option value="A">Pay Later</option>
    //       </select>
    //     </div>
    //   );
    // } 
    if (searchField === "OrderStatus") {
      return (
        <div className="orders-dropdown">
          <select
            className="search-ord"
            ref={this.searchInputRef}
            onChange={this.handleChange}
          >
            <option value="">Select</option>
            <option value="Orders Placed">Orders Placed</option>
            <option value="New Order">New Order</option>
            <option value="Acknowledged">Acknowledged</option>
            <option value="Acknl  Being Picked">Acknl Being Picked</option>
            <option value="Invoiced">Invoiced</option>
            <option value="Part Desp.  Inv.">Part Desp. Inv.</option>
            <option value="Cancelled">Cancelled</option>
          </select>
        </div>
      );
    } 
    // else if (searchField === "mainDepot") {
    //   return (
    //     <select
    //       ref={this.searchInputRef}
    //       className="search-ord"
    //       onChange={(e) => this.handleChange(e)}
    //     >
    //       <option value="">Select</option>
    //       {this.state.mainDepotList.map((item) => (
    //         <option key={item.mainDepot} value={item.mainDepot}>
    //           {item.mainDepot}
    //         </option>
    //       ))}
    //     </select>
    //   );
    // } 
    // else if (searchField === "subDepot") {
    //   return (
    //     <select
    //       ref={this.searchInputRef}
    //       className="search-ord"
    //       onChange={(e) => this.handleChange(e)}
    //     >
    //       <option value="">Select</option>
    //       {this.state.subDepotList.map((item) => (
    //         <option key={item.subDepot} value={item.subDepot}>
    //           {item.subDepot}
    //         </option>
    //       ))}
    //     </select>
    //   );
    // } 
    else if (searchField === "PriceBand") {
      return (
        <div>
          <input
            type="text"
            ref={this.searchInputRef}
            onChange={this.handlePriceBandChange}
            placeholder={`Search by ${this.state.searchFieldtxt}`}
          />
          {/* autosuggestion for priceband */}
          {this.state.searchTextVal.trim() !== "" &&
            this.state.suggestions.length > 0 && (
              <ul className="suggestions-list">
                {this.state.suggestions.map((item, index) => (
                  <li
                    key={index}
                    onClick={() => this.handleSuggestionClick(item)}
                  >
                    {item}
                  </li>
                ))}
              </ul>
            )}
          {/* autosuggestion for priceband */}
        </div>
      );
    } 
    // else if (searchField === "hasPromoPinsa") {
    //   return (
    //     <select
    //       ref={this.searchInputRef}
    //       className="search-ord"
    //       onChange={(e) => this.handleChange(e)}
    //       defaultValue=""
    //     >
    //       <option value="">Select</option>
    //       <option value="all">All</option>
    //       {this.state.sectorList.map((item, index) => (
    //         <option key={item._id} value={item.MasterValue}>
    //           {item.MasterValue}
    //         </option>
    //       ))}
    //     </select>
    //   );
    // } 
    else {
      return (
        <input
          type="text"
          ref={this.searchInputRef}
          onChange={this.handleChange}
          placeholder={`Search by ${this.state.searchFieldtxt}`}
        />
      );
    }
  };

  handleSuggestionClick = (selectedValue) => {
    if (this.searchInputRef.current) {
      this.searchInputRef.current.value = selectedValue;
    }
    const searchData = this.state.temporders.filter(
      (item) => item.Priceband == selectedValue,
    );
    this.setState({
      orders: searchData,
      suggestions: [],
      searchTextVal: selectedValue,
      searchstate: true,
    });
  };

  orderNotelog = (order) => {
    this.setState({ isLoading: true });
    var loginDetails = {};
    let responseData = [];
    if (sessionStorage.getItem("authData")) {
      loginDetails = JSON.parse(sessionStorage.getItem("authData"));
    }
    let URL = BaseUrl + "admin/orderlog/" + order.OrderNumber;
    this.setState({ isLoading: true, notesPopup: true, currentOrder: order });
    http
      .get(URL)
      .then(async (response) => {
        responseData = response.data.data;
        this.setState({
          isLoading: false,
          orderlogs: responseData,
          notesPopup: true,
        });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
        console.error("Error getting status:", error);
      });
  };

  hideNotePopup = () => {
    this.setState({
      notesPopup: false,
      noteError: false,
      orderlogs: "",
      note: "",
    });
  };

  updateNoteLog = () => {
    if (this.state.note.trim() !== "") {
      var loginDetails = {};
      if (sessionStorage.getItem("authData")) {
        loginDetails = JSON.parse(sessionStorage.getItem("authData"));
      }
      let noteURL = BaseUrl + "admin/orderlog";
      const notepayload = {
        orderID: this.state.currentOrder.OrderNumber,
        noteText: this.state.note,
        createdBy: loginDetails.adminName,
      };
      this.setState({ isLoading: true });
      http
        .post(noteURL, notepayload)
        .then(async (response) => {
          this.setState({
            notesPopup: false,
            isLoading: false,
            showPopup: true,
            uploadMessage: "Order Note submitted successfully!",
          });
        })
        .catch((error) => {
          this.setState({ isLoading: false });
          console.error("Error submitting note:", error);
        });
    } else {
      this.setState({ noteError: true });
    }
  };

  render() {
    if (sessionStorage.getItem("authData")) {
      var loginEmail = JSON.parse(
        sessionStorage.getItem("authData"),
      ).adminEmail;
    }
    const columns = [
      {
        name: "Order #",
        selector: (row) => row.OrderNumber,
        sortable: true,
      },
      {
        name: "Account Code",
        selector: (row) => row.accountCode,
        sortable: true,
      },
      // {
      //   name: "Payment Method",
      //   selector: (row) =>
      //     row.PaymentMethod === "A"
      //       ? row.OrderPaid === "YES"
      //         ? "Paid (Pay Later)"
      //         : "Pay Later"
      //       : "Online Payment",
      //   sortable: true,
      // },
      // {
      //   name: "Order Total (Excl. of VAT)",
      //   selector: (row) => this.priceFormat(row.OrderTotal),
      //   sortable: true,
      //   sortFunction: (a, b) => {
      //     const totalA = parseFloat(a.OrderTotal) || 0;
      //     const totalB = parseFloat(b.OrderTotal) || 0;
      //     return totalA - totalB;
      //   },
      // },
      {
        name: "Ordered Date",
        selector: (row) => moment(row.createdAt).format("DD/MM/YYYY"),
        sortable: false,
      },
      {
        name: "Delivery Date",
        selector: (row) => row.DateRequired,
        sortable: true,
        sortFunction: (a, b) => {
          const parseDate = (dateStr) => {
            const [day, month, year] = dateStr.split("/").map(Number);
            return new Date(year, month - 1, day);
          };
          const dateA = parseDate(a.DateRequired);
          const dateB = parseDate(b.DateRequired);
          return dateA - dateB;
        },
      },
      {
        name: "Status",
        selector: (row) => row.OrderStatus,
        sortable: true,
      },
      {
        name: "Actions",
        selector: (row, index) => (
          <div className="order-action-tbl">
            
              <a
                className="title-tooltip title-up button"
                data-title="View Details"
                style={{ color: "white" }}
                onClick={() =>
                  this.getOrderaccountdetails(row.accountCode, row)
                }
              >
                <i className="fa fa-eye" aria-hidden="true"></i>
              </a>
                       
              <a
                className="button title-tooltip title-up"
                data-title="Order Note Log"
                onClick={() => this.orderNotelog(row)}
              >
                <i className="fa fa-history"></i>
              </a>
                       
              <a
                className="refresh-btn title-tooltip title-up"
                data-title="Click to view the updated status and details of this order"
                onClick={this.orderRefresh.bind(this, row)}
              >
                <i
                  className="fa fa-refresh"
                  id={"refresh_order_id" + row.OrderNumber}
                  aria-hidden="true"
                ></i>{" "}
              </a>
            
          </div>
        ),
        sortable: false,
      },
    ];

    const customStyles = {
      rows: {
        style: {
          minHeight: "25px",
        },
      },
      headCells: {
        style: {
          padding: "8px",
        },
      },
      cells: {
        style: {
          padding: "8px",
        },
      },
    };

    const paginationComponentOptions = {
      rowsPerPageText: "",
      rangeSeparatorText: "",
      selectAllRowsItem: true,
      selectAllRowsItemText: "",
      noRowsPerPage: "",
    };

    var datelabel = "";
    var dateValue = "";
    if (this.state.dateRange === "1") {
      datelabel = "Past 30 Days";
      dateValue = "1";
    } else if (this.state.dateRange === "3") {
      datelabel = "Past 90 Days";
      dateValue = "3";
    } else if (this.state.dateRange === "6") {
      datelabel = "Past 180 Days";
      dateValue = "6";
    } else if (this.state.dateRange === "365") {
      datelabel = "Past 1 Year";
      dateValue = "1Year";
    } else if (this.state.dateRange === "custom") {
      datelabel = "Custom";
      dateValue = "custom";
    } else if (this.state.dateRange === "") {
      datelabel = "Past 30 Days";
      dateValue = "1";
    }

    const nodatacomponent =
      this.state.searchstate === false ? (
        this.state.datefromLabel && this.state.datetoLabel ? (
          <div className="no-records-found">
            Sorry, there are no order records found from{" "}
            {this.formatDate(this.state.datefromLabel)} to{" "}
            {this.formatDate(this.state.datetoLabel)}. Please consider using
            more filter option to refine your search.
          </div>
        ) : (
          <div className="no-records-found">
            Sorry, there are no order records found for {this.state.datelabel}.
            Please consider using more filter option to refine your search.
          </div>
        )
      ) : (
        <div className="no-records-found">
          Sorry, no orders were matching your keyword, please try again with a
          different search term.
        </div>
      );

    return (
      <>
        {this.state.alertPopup === true && (
          <CommonAlert title="Alert" message={this.state.alertMessage} />
        )}
        <section className="dashboard-block">
          <Sidebar />
          <div className="dash-left">
            <Header />
            <div className="cart-block">
              <div className="container">
                <div className="flex-title">
                  <h1 className="checkout-title">Kitchen Orders</h1>
                    <div className="prod-import-btn odr-expo-btn">
                        <a href="orders">
                            <button 
                                type="button"
                                title="Back"
                            >
                                Back
                            </button>
                        </a>
                        {/* Export Button */}
                        <>
                           
                                <a
                                    data-title="Export Filtered Records"
                                    className="export-btn button title-tooltip title-left"
                                    onClick={this.handleConfirmExportToExcel}
                                    >
                                    Export
                                </a>
                           
                        </>
                    </div>
                </div>
                <div className="right-table-outer-wrap">
                  <div className="table-filter search-orders orders-search-bx">
                    <div className="orders-drop-left">
                      <div className="orders-dropdown">
                        <select
                          className="handle-srch"
                          ref={this.searchFieldRef}
                          onChange={this.handleSearchFieldChange}
                        >
                          <option value="" disabled>
                            Search by Field
                          </option>
                          <option value="OrderNumber">Order Number</option>
                          <option value="OrderStatus">Order Status</option>
                          <option value="accountCode">Account Code</option>
                          {/* <option value="PaymentMethod">Payment Method</option> */}
                          <option value="PriceBand">Price Band</option>
                          {/* <option value="mainDepot">Main Depot</option> */}
                          {/* <option value="subDepot">Local Depot</option> */}
                          {/* <option value="placedBy">
                            Order by HO/Chef Account
                          </option> */}
                          {/* <option value="hasPromoPinsa">
                            Sector-Based Promo Offer
                          </option> */}
                        </select>
                      </div>
                      <div className="table-search-reset">
                        <div className="table-search">
                          {this.renderSearchInput()}
                        </div>
                        <button
                          className="submitbtn button search-ord-btn"
                          onClick={this.filterData}
                        >
                          <i className="fa fa-search"></i>
                        </button>
                        <button
                          className="resetbtn"
                          type="reset"
                          onClick={this.handleReset}
                        >
                          Reset
                        </button>
                      </div>
                    </div>
                    <div className="select-drop" ref={this.dropdownRef}>
                      <a
                        className={
                          this.state.isElementVisible == true
                            ? "filter-btn button active"
                            : "filter-btn button"
                        }
                        onClick={this.openFilter}
                      >
                        More Filter{" "}
                        <span className="filter-icon">
                          <i className="fa fa-sliders" aria-hidden="true"></i>
                        </span>
                      </a>
                      <div
                        className={
                          this.state.isElementVisible == true
                            ? "filter-bx show"
                            : "filter-bx"
                        }
                      >
                        <div className="filter-date-range">
                          <div className="fltr-dt-wrap">
                            <label>Date Range (Ordered Date):</label>
                            <Select
                              value={this.state.selectedDateOption}
                              options={this.state.rangeOptions}
                              theme={(theme) => ({
                                ...theme,
                                borderRadius: 6,
                                height: 40,
                                colors: {
                                  ...theme.colors,
                                  primary25: "#e0dedb",
                                  primary: "#ec2f45",
                                },
                              })}
                              onChange={this.handleFilterChange}
                            />
                          </div>
                        </div>
                        <div
                          className={
                            this.state.datepickershow == true
                              ? "fltr-dt-range show"
                              : "fltr-dt-range"
                          }
                        >
                          <div className="fltr--date">
                            <span>From</span>
                            <DatePicker
                              selected={this.state.datefrom}
                              placeholderText="From date"
                              showDisabledMonthNavigation
                              dateFormat="dd/MM/yyyy"
                              disablePast={true}
                              maxDate={new Date()}
                              onChange={(date) => this.DateChange(date, "from")}
                            />
                            <span className="date-icon">
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                          <div className="fltr--date">
                            <span>To</span>
                            <DatePicker
                              selected={this.state.dateto}
                              placeholderText="To date"
                              showDisabledMonthNavigation
                              dateFormat="dd/MM/yyyy"
                              disablePast={true}
                              maxDate={new Date()}
                              onChange={(date) => this.DateChange(date, "to")}
                            />
                            <span className="date-icon">
                              <i
                                className="fa fa-calendar"
                                aria-hidden="true"
                              ></i>
                            </span>
                          </div>
                        </div>
                        {this.state.dateinvalid_error === true && (
                          <span className="color-red">
                            Invalid Start & End date!
                          </span>
                        )}
                        {this.state.datefill_error === true && (
                          <span className="color-red">
                            Please fill the from and to date!
                          </span>
                        )}
                        <div className="filter-btns">
                          <button
                            type="button"
                            className="button clear-btn"
                            onClick={this.clearFilterOrderSearch.bind(this)}
                          >
                            Clear
                          </button>
                          <button
                            type="button"
                            className="button apply-btn"
                            onClick={this.handleApplyOrderFilters.bind(this)}
                          >
                            Apply{" "}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.orders.length > 0 &&
                    this.state.loading === false && (
                      <p className="admin-order account-total-records">
                        Total Records:{" "}
                        {this.state.orders.length > 0
                          ? this.orderRecordsTotal(this.state.orders)
                              .totalOrderCount
                          : ""}
                        {this.state.datefromLabel && this.state.datetoLabel ? (
                          <span>
                            {" "}
                            (From {this.formatDate(
                              this.state.datefromLabel,
                            )} to {this.formatDate(this.state.datetoLabel)})
                          </span>
                        ) :
                        this.state.datelabel ? (
                          ` (${this.state.datelabel})`
                        ) : (
                          ""
                        )}
                        {/* {this.state.orders.length > 0 &&
                          this.state.loading === false && (
                            <span className="ord-TotalAmt">
                              {""} Total Order Amount (Incl. of VAT):{" "}
                              {this.state.orders.length > 0
                                ? this.orderRecordsTotal(this.state.orders)
                                    .totalOrderAmount
                                : "0.00"}{" "}
                            </span>
                          )} */}
                      </p>
                    )}
                  <div className="checkout-table table_overflow orders-table">
                    <DataTable
                      columns={columns}
                      //  noDataComponent="Sorry, no orders were matching your keyword, try a new search."
                      noDataComponent={nodatacomponent}
                      data={this.state.orders}
                      customStyles={customStyles}
                      pagination
                      paginationPerPage={25}
                      progressPending={this.state.loading}
                      paginationRowsPerPageOptions={[25, 50, 75, 100]}
                      paginationComponentOptions={paginationComponentOptions}
                    />
                  </div>
                </div>
              </div>
              <Footer />
            </div>
          </div>
          {this.state.popupView}
        </section>
        {/* Loader & Popup START */}
        <div className="common">
        </div>
        {/* Loader & Poupp END */}
        {this.state.notesPopup && (
          <Popup
            extClass="info-poup show"
            closebtn={
              <>
                <span onClick={this.hideNotePopup} className="close"></span>
              </>
            }
            headMoreTxt={
              <>
                <div className="order-top">
                  <h4>
                    <span>
                      Notes for Order - {this.state.currentOrder.OrderNumber}
                    </span>
                  </h4>
                </div>
              </>
            }
            bodyMoreTxt={
              <>
                <div className="bottom vendor-details ordernotes-log">
                  <div className="order-notes">
                    <div className="input-field">
                      <label for="note-label">Enter your note</label>
                      <textarea
                        name="note"
                        onChange={(e) => this.handleNoteChange(e.target.value)}
                      ></textarea>
                      {this.state.noteError && (
                        <div className="err-msg">Please update some note</div>
                      )}
                    </div>
                  </div>
                  <div className="alert-buttons btn-field btn-center">
                    <button
                      onClick={this.updateNoteLog}
                      className="popup-alert-btn button"
                    >
                      Submit
                    </button>
                    <button
                      onClick={this.hideNotePopup}
                      className="popup-alert-btn button"
                    >
                      Cancel
                    </button>
                  </div>
                  {this.state.isLoading ? (
                    <div className="loading-buffer"></div>
                  ) : (
                    <div className="order-notes-log">
                      {this.state.orderlogs &&
                        this.state.orderlogs.length > 0 &&
                        this.state.orderlogs.map((ord_item) => {
                          return (
                            <div className="info-item">
                              <div className="info-innr">
                                <p>
                                  <span className="labeltxt">Date: </span>
                                  {dateformatwithuktime(ord_item.createdAt)}
                                </p>
                                <p>
                                  <span className="labeltxt log-reason">
                                    Note:{" "}
                                  </span>
                                  {ord_item.noteText}
                                </p>
                                <p>
                                  <span className="labeltxt log-reason">
                                    Created by:{" "}
                                  </span>
                                  {ord_item.createdBy}
                                </p>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              </>
            }
          />
        )}
        {this.state.showPopup && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>Alert</h4>
                </div>
                <div className="custom-alert-body">
                  <p>{this.state.uploadMessage}</p>

                  <div className="alert-buttons">
                    <button
                      onClick={this.closePopup}
                      className="popup-alert-btn button"
                    >
                      ok
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.refreshLoading && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-body alert-no-header">
                  <div className="fth-latest-orders-alert">
                    <h4>Fetching latest order details</h4>
                    <p>
                      <i className="fa fa-spinner spin" aria-hidden="true"></i>{" "}
                      Please wait, we are fetching the latest order details...
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.visibleAlert === true && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>Alert</h4>
                </div>
                <div className="custom-alert-body">
                  <p>Are you sure you want to export the order report data?</p>
                  <div className="alert-buttons">
                    <a
                      onClick={this.handleExportToExcel.bind(this)}
                      className="popup-alert-btn button"
                    >
                      OK
                    </a>
                    <a
                      onClick={this.alertPopupclose.bind(this)}
                      className="popup-alert-btn button"
                    >
                      Cancel
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {this.state.visibleNoDataAlert && (
          <div className="custom-alert-pop paylater-popup">
            <div className="custom-alert-container">
              <div className="custom-alert-wrap">
                <div className="custom-alert-header">
                  <h4>Alert</h4>
                </div>
                <div className="custom-alert-body">
                  <p>There is no order records available for export.</p>
                  <div className="alert-buttons">
                    <a
                      onClick={this.handleCloseNoDataAlert}
                      className="popup-alert-btn button"
                    >
                      OK
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default KitchenOrders;
